<script>
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
export default {
    components: {
        Multiselect,
        MaskedInput
    },
    data(){
        return {
            quantityMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
            }),
            modalTitle: "Create Process Type",
            form: {
                officeId: this.$store.state.data.selectedDU.id,
                processName: "",
                easeOfDoingBusinessType: "",
                estimatedWorkingDays: "",
                daysToRemindOfficeProcessor: "",
                parentProcessTypeId: 0,
                targetCustomer: "",
                category: "",
            },
            easeOfDoingBusiness: null,
            easeOfDoingBusinessOptions: [
                {
                    option: "Simple Process",
                    easeOfDoingBusinessType: "Simple Process",
                    estimatedWorkingDays: "3",
                    daysToRemindOfficeProcessor: "2",
                },
                {
                    option: "Complex Process",
                    easeOfDoingBusinessType: "Complex Process",
                    estimatedWorkingDays: "7",
                    daysToRemindOfficeProcessor: "6",
                },
                {
                    option: "Highly Technical Process",
                    easeOfDoingBusinessType: "Highly Technical Process",
                    estimatedWorkingDays: "20",
                    daysToRemindOfficeProcessor: "19",
                },
                {
                    option: "Highly Technical/Discretional Process",
                    easeOfDoingBusinessType: "Highly Technical/Discretional Process",
                    estimatedWorkingDays: "20",
                    daysToRemindOfficeProcessor: "19",
                },
                {
                    option: "Others",
                    easeOfDoingBusinessType: "",
                    estimatedWorkingDays: "",
                    daysToRemindOfficeProcessor: "",
                },
            ],
            categories: [
                'G2B - Government to Business',
                'G2C - Government to Citizen',
                'G2G - Government to Government',
            ],
            submitted: false,
        }
    },
    validations: {
        form: {
            processName: { required },
            easeOfDoingBusinessType: { required },
            estimatedWorkingDays: { required },
            daysToRemindOfficeProcessor: { required },
            targetCustomer: { required },
            category: { required },
        },
    },
    methods: {
        onSubmit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.$emit("onSubmit", this.form);
        },
        setData(data){
            this.form = data.form;
            this.easeOfDoingBusiness = data.easeOfDoingBusiness;
        },
        onReset() {
            this.submitted = false;
            this.$v.$reset();
            this.form = {
                officeId: this.$store.state.data.selectedDU.id,
                processName: "",
                easeOfDoingBusinessType: "",
                estimatedWorkingDays: "",
                daysToRemindOfficeProcessor: "",
                parentProcessTypeId: 0,
                targetCustomer: "",
                category: "",
            };
        },
        easeOfDoingBusinessLabel({ option }) {
            return `${option}`;
        },
        selecteaseOfDoingBusiness() {
            this.form.easeOfDoingBusinessType =
                this.easeOfDoingBusiness.easeOfDoingBusinessType != "Others"
                ? this.easeOfDoingBusiness.easeOfDoingBusinessType
                : "";
            this.form.estimatedWorkingDays =
                this.easeOfDoingBusiness.estimatedWorkingDays;
            this.form.daysToRemindOfficeProcessor =
                this.easeOfDoingBusiness.daysToRemindOfficeProcessor;
            this.$forceUpdate();
        },
    },
}
</script>
<template>
    <b-modal
        id="process-type-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <form
            @submit.prevent="onSubmit"
            class="needs-validation"
            ref="targetForm"
        >
            <div class="mb-3">
                <label for="processName">Name </label>
                <input
                    id="processName"
                    type="text"
                    v-model="form.processName"
                    placeholder="Enter Name..."
                    class="form-control"
                    :class="{
                    'is-invalid': submitted && $v.form.processName.$error,
                    }"
                    autocomplete="off"
                />
                <div
                    v-if="submitted && $v.form.processName.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.processName.required">
                        This value is required.
                    </span>
                </div>
            </div>
            <div class="mb-3">
                <label for="processDesc">Description</label>
                <input
                    id="processDesc"
                    type="text"
                    v-model="form.processDescription"
                    placeholder="Enter Description..."
                    class="form-control"
                    autocomplete="off"
                />
            </div>
            <div class="mb-3">
                <label for="category">Category</label>
                <multiselect
                    v-model="form.category"
                    :multiple="true"
                    :options="categories"
                    placeholder="Enter Category..."
                    :class="{
                        'is-invalid': submitted && $v.form.category.$error,
                    }"
                    autocomplete="off"
                    :close-on-select="false"
                >
                </multiselect>
                <!-- <input
                    id="category"
                    type="text"
                    v-model="form.category"
                    placeholder="Enter Category..."
                    class="form-control"
                    autocomplete="off"
                /> -->
            </div>
            <div class="mb-3">
                <label for="targetCustomer">Target Customer</label>
                <input
                    id="targetCustomer"
                    type="text"
                    v-model="form.targetCustomer"
                    placeholder="Enter Target Customer..."
                    class="form-control"
                    autocomplete="off"
                    :class="{
                    'is-invalid': submitted && $v.form.targetCustomer.$error,
                    }"
                />
                <div
                    v-if="submitted && $v.form.targetCustomer.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.targetCustomer.required"
                    >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="easeOfDoingBusinessType">Ease of Doing Business </label>
                <multiselect
                    id="easeOfDoingBusinessType"
                    v-model="easeOfDoingBusiness"
                    track-by="option"
                    label="option"
                    placeholder="Select Action Request/Purpose..."
                    :custom-label="easeOfDoingBusinessLabel"
                    :show-labels="false"
                    :options="easeOfDoingBusinessOptions"
                    :searchable="false"
                    :multiple="false"
                    :allow-empty="false"
                    :close-on-select="true"
                    @input="selecteaseOfDoingBusiness"
                    :class="{
                        'is-invalid': submitted && $v.form.easeOfDoingBusinessType.$error,
                    }"
                >
                </multiselect>
                <b-collapse
                    :visible="
                    easeOfDoingBusiness && easeOfDoingBusiness.option == 'Others'
                    "
                >
                    <div
                    v-if="
                        easeOfDoingBusiness && easeOfDoingBusiness.option == 'Others'
                    "
                    class="mx-3 mt-2"
                    >
                    <input
                        id="easeOfDoingBusinessType"
                        type="text"
                        v-model="form.easeOfDoingBusinessType"
                        placeholder="Enter Ease of Doing Business..."
                        class="form-control"
                        :class="{
                        'is-invalid':
                            submitted && $v.form.easeOfDoingBusinessType.$error,
                        }"
                        autocomplete="off"
                    />
                    </div>
                </b-collapse>
                <div
                    v-if="submitted && $v.form.easeOfDoingBusinessType.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.easeOfDoingBusinessType.required"
                    >This value is required.</span
                    >
                </div>
            </div>
            <b-collapse :visible="easeOfDoingBusiness != null">
                <div v-if="easeOfDoingBusiness != null">
                    <div class="mb-3">
                    <label for="estimatedWorkingDays">Estimated Working Days </label>
                    <masked-input
                        :mask="quantityMask"
                        id="estimatedWorkingDays"
                        type="text"
                        v-model="form.estimatedWorkingDays"
                        placeholder="Enter Estimated Working Days..."
                        class="form-control"
                        :class="{
                        'is-invalid':
                            submitted && $v.form.estimatedWorkingDays.$error,
                        }"
                        autocomplete="off"
                    ></masked-input>
                    <div
                        v-if="submitted && $v.form.estimatedWorkingDays.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.estimatedWorkingDays.required"
                        >This value is required.</span
                        >
                    </div>
                    </div>
                    <div class="mb-3">
                    <label for="daysToRemindOfficeProcessor"
                        >Days to Remind Office Processor
                    </label>
                    <masked-input
                        :mask="quantityMask"
                        id="daysToRemindOfficeProcessor"
                        type="text"
                        v-model="form.daysToRemindOfficeProcessor"
                        placeholder="Enter Days to Remind Office Processor..."
                        class="form-control"
                        :class="{
                        'is-invalid':
                            submitted && $v.form.daysToRemindOfficeProcessor.$error,
                        }"
                        autocomplete="off"
                    ></masked-input>
                    <div
                        v-if="submitted && $v.form.daysToRemindOfficeProcessor.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.daysToRemindOfficeProcessor.required"
                        >This value is required.</span
                        >
                    </div>
                    </div>
                </div>
            </b-collapse>
            <div class="d-flex float-end">
                <button type="submit" class="btn btn-primary">Submit</button>
            </div>
        </form>
    </b-modal>
</template>